<template>
    <!-- <Dropdown placement="bottom-end" @on-click="switchSort" transfer trigger="click">
      <ButtonGroup>
        <Button
          size="small"
          :icon="currentOrder == 'asc' ? 'md-arrow-round-up' : 'md-arrow-round-down'" @click.stop="switchOrder"></Button>
        <Button size="small">
          <span>{{ sortLable }}</span>
          <Icon type="md-arrow-dropdown" />
        </Button>
      </ButtonGroup>
      <DropdownMenu slot="list">
        <DropdownItem
          v-for="{key, label, icon} of list"
          :key="key"
          :name="key"
          :selected="currentSort == key">
          <Icon :type="icon" />
          <span>按{{ label }}</span>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown> -->
    <div class="choose_sort">
      <div :class="{'sort-item':true,'active': currentSort == 'create_time'}" @click="switchSort('create_time')">按时间</div>
      <div :class="{'sort-item':true,'active': currentSort == 'vote_num'}" @click="switchSort('vote_num')">按热度</div>
      <div :class="{'current':true,'hot': currentSort == 'vote_num'}"></div>
    </div>
</template>

<script type="text/javascript">
export default {
  name: 'dropdown-sort',
  data () {
    return {
      currentSort: 'create_time',
    }
  },
  props: {
    sort: String,
    isTopic: {
      type: Boolean,
      default: false
    },
    isComment: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    switchSort (sort) {
      if(sort == this.currentSort) {
        return
      }
      this.currentSort = sort
      this.$emit('update:sort', this.currentSort)
      if(this.isTopic) {
        this.$emit('refreshComment')
      }
      if(this.isComment) {
        this.$emit('refreshPopComment')
      }
    }
  },
  watch: {
    'sort': {
      immediate: true,
      handler (sort) {
        if (sort == this.currentSort) return
        this.currentSort = sort
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .choose_sort {
    width: 5.5rem;
    height: 1.4rem;
    border-radius: 10rem;
    display: flex;
    align-items: center;
    background-color: #656565;
    position: relative;
    .sort-item {
      height: 100%;
      line-height: 1.4rem;
      flex: 1;
      text-align: center;
      color: #fff;
      font-size: .6rem;
      z-index: 10;
      &.active {
        color: #5a5a5a;
      }
    }
    .current {
      position: absolute;
      z-index: 9;
      top: 0;
      left: 0;
      width: 2.75rem;
      height: 1.4rem;
      background-color: #fff;
      border-radius: 10rem;
      transition: all ease .5s;
      -webkit-transition: all ease .5s;
      -o-transition: all ease .5s;
      -moz-transition: all ease .5s;
      transform: translateX(0);
      &.hot {
        transform: translateX(2.75rem);
      }
    }
  }
</style>